/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
export function CacheDeps(deps: string[]) {
	return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
		const originalGetter = descriptor.get!;
		const cache = new WeakMap<any, { value: any; snapshot: any }>();

		descriptor.get = function (this: any) {
			const snapshot = deps.map((key) => this[key]);
			const cached = cache.get(this);

			if (!cached || !shallowEqual(cached.snapshot, snapshot)) {
				const value = originalGetter.call(this);
				cache.set(this, { value, snapshot });
				return value;
			}

			return cached.value;
		};
	};
}

function shallowEqual(a: any[], b: any[]): boolean {
	return a.length === b.length && a.every((v, i) => v === b[i]);
}

export function CachedResult<T>(deps: (keyof T)[]) {
	const cache = new Map<string, any>();
	return function (target: T, propertyKey: string, descriptor: PropertyDescriptor) {
		const originalMethod = descriptor.value;
		descriptor.value = function (this: any, ...args: any[]) {
			const depSnapshot = deps.map((dep) => this[dep]);
			// 这里性能真的会变好吗，序列化操作
			const key = JSON.stringify([...args, ...depSnapshot]);
			if (cache.has(key)) {
				return cache.get(key);
			}
			const result = originalMethod.apply(this, args);
			cache.set(key, result);
			return result;
		};
	};
}
